export default "__VITE_ASSET__D5z7PnAq__"